"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (typeof localStorage === "undefined" || localStorage === null) {
    // tslint:disable-next-line:no-var-requires
    const LocalStorage = require("node-localstorage").LocalStorage;
    global.localStorage = new LocalStorage("./localStorage");
}
const LocalStorageCookie = {
    setCookie: (key, value) => {
        localStorage.setItem(key, value.id);
    },
    getCookie: (key) => {
        const value = localStorage.getItem(key);
        return value || undefined;
    },
    removeCookie: (key) => {
        localStorage.removeItem(key);
    },
};
exports.default = LocalStorageCookie;
//# sourceMappingURL=LocalStorageCookie.js.map